document.addEventListener('click', (e) => {
  const btn = e.target.closest('.variant-tooltip__icon');

  // Close all open tooltips first
  document.querySelectorAll('.variant-tooltip--open').forEach((t) => {
    if (!btn || t !== btn.closest('.variant-tooltip')) {
      t.classList.remove('variant-tooltip--open');
    }
  });

  if (btn) {
    e.stopPropagation();
    btn.closest('.variant-tooltip').classList.toggle('variant-tooltip--open');
  }
});

// Close on Escape
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.variant-tooltip--open').forEach((t) => t.classList.remove('variant-tooltip--open'));
  }
});